// stores/depotStore/DepotStore.ts
import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { depotService } from "services/depot.service";
import authStore from "stores/auth/AuthStore";
import { Depot } from "types/depot.type";

class DepotStore {
  depots: Depot[] = [];
  loading: boolean = false;
  selectedDepot: Depot | null = null;
  total = 0;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchDepots(page: number = 1, limit: number = 10, filters: any = {}) {
    if (!authStore.isAuthenticated()) return;

    this.loading = true;
    try {
      const { data, total } = await depotService.getAll(page, limit, filters);
      runInAction(() => {
        this.depots = data;
        this.total = total;
      });
    } catch (error: any) {
      if (
        error?.response?.data?.type === "role_changed" ||
        error?.response?.data?.type === "account_inactive"
      ) {
        return;
      }
      toast.error("Erreur lors du chargement des dépôts");
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async saveDepot(depot: Partial<Depot>) {
    this.loading = true;
    try {
      if (depot.id) {
        await depotService.update(depot.id, depot);
        toast.success("Dépôt mis à jour !");
      } else {
        await depotService.create(depot);
        toast.success("Dépôt créé !");
      }
      await this.fetchDepots();
      this.setSelected(null);
    } catch (error) {
      //   toast.error("Erreur lors de l'enregistrement");
      throw error;
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async deleteDepot(id: number) {
    this.loading = true;
    try {
      await depotService.delete(id);
      toast.success("Dépôt supprimé !");
      await this.fetchDepots();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  setSelected(depot: Depot | null) {
    this.selectedDepot = depot;
  }
}

const depotStore = new DepotStore();
export default depotStore;
